import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import "./home.css";

import { ROLE } from "../../../../shared/constants/common";
import { getUserRole, isUserLoggedIn } from "../../../../shared/utils/function";
import useNavigation from "../../../../shared/utils/useNavigation";
import ModernHeader from "../../../../components/layout/Headers/ModernHeader";
import ModernFootermenu from "../../../../components/layout/Footer";
import { ROUTES } from "../../../../shared/constants/routes";
import FeedTab from "./Sections/feedTab";
import SubscriptionsTab from "./Sections/subscriptionsTab";
import PurchasedTab from "./Sections/purchasedTab";



const ModernHomeScreen = ({
  location,
  user, // coming form mapStateToProps
}) => {
  const role = getUserRole();
  const isLoggedInUser = isUserLoggedIn();
  const navigate = useNavigation();
  const isCreator = role === ROLE.CREATOR_SUB || role === ROLE.CREATOR_CONTENT;
  const [activeTab, setActiveTab] = useState("feed");

  useEffect(() => {
    const path = location.pathname;
    if (path.includes(ROUTES.MODERN_FEED)) {
      setActiveTab('feed');
    } else if (path.includes(ROUTES.MODERN_SUBSCRIPTIONS)) {
      setActiveTab('subscriptions');
    } else if (path.includes(ROUTES.MODERN_PURCHASED)) {
      setActiveTab('purchased');
    } else {
      setActiveTab('subscriptions');
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!isLoggedInUser) {
      navigate.toDiscover();
    } else if (isCreator) {
      navigate.toProfile();
    }
  }, [isLoggedInUser, isCreator, navigate]);

  if (!isLoggedInUser || isCreator) {
    return null;
  }

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    const navigationMap = {
      feed: () => navigate.toFeed(),
      subscriptions: () => navigate.toSubscriptions(),
      purchased: () => navigate.toPurchased(),
    };
    navigationMap[tab]?.();
  };

  return (
    <div className={`modern-home-screen`}>
      {/* Header */}
      <ModernHeader
        showButtonBorder={false}
        hideSearchIcon={false}
        showAvatar={true}
      />

      <div className="cm_main_tab_wrapper">
        <section className="main-tabs cm_main_tab pwa_top_padding">
          <div className="tabs-container">
            {[
              { id: "feed", label: "Feed" },
              { id: "subscriptions", label: "Subscriptions" },
              { id: "purchased", label: "Purchased" },
            ].map((tab) => (
              <button
                key={tab.id}
                className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => handleTabChange(tab.id)}
              >
                {tab.label}
                {activeTab === tab.id && <div className="active-indicator"></div>}
              </button>
            ))}
          </div>
        </section>
      </div>

      <div className="tab-content pwa_top_padding pb_100">
        {activeTab === "feed" && <FeedTab />}
        {activeTab === "subscriptions" && <SubscriptionsTab />}
        {activeTab === "purchased" && <PurchasedTab />}
      </div>

      <ModernFootermenu />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user?.user,
  };
};

export default connect(mapStateToProps)(ModernHomeScreen);